import { NoteAlertOutlineIcon } from './NoteAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 52710BFA-E892-49B7-9157-8C9A5E08BC21
 * name note-alert-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const PostItNoteAlertOutlineIcon = NoteAlertOutlineIcon;
export default PostItNoteAlertOutlineIcon